import { render, staticRenderFns } from "./actionModel.vue?vue&type=template&id=23083e06&scoped=true&"
import script from "./actionModel.vue?vue&type=script&lang=js&"
export * from "./actionModel.vue?vue&type=script&lang=js&"
import style0 from "./actionModel.vue?vue&type=style&index=0&id=23083e06&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23083e06",
  null
  
)

export default component.exports